import { render, staticRenderFns } from "./MFormVuetifyTextarea.vue?vue&type=template&id=2bc4033a&scoped=true"
import script from "./MFormVuetifyTextarea.vue?vue&type=script&lang=js"
export * from "./MFormVuetifyTextarea.vue?vue&type=script&lang=js"
import style0 from "./MFormVuetifyTextarea.vue?vue&type=style&index=0&id=2bc4033a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4033a",
  null
  
)

export default component.exports